import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { api_url } from "../config/config";

const ListOrder = () => {
    const tableRef = useRef(null);

    const [orders, setOrders] = useState([]);
    const token = localStorage.getItem('admin_token');

    const [filters, setFilters] = useState({
        date: "",
        amount: "",
        city: "",
    });


    const [debouncedFilters, setDebouncedFilters] = useState(filters); // Store the debounced filter values
    const [trigger, setTrigger] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [newStatus, setNewStatus] = useState("");

    // Update order status locally
    const updateOrderStatus = (id, status) => {
        const updatedOrders = orders.map((order) =>
            order.id === id ? { ...order, status } : order
        );
        setOrders(updatedOrders);
        setSelectedOrder(null);
    };

    // Fetch Orders with filters
    const fetchOrder = async () => {
        const { date, amount, city } = debouncedFilters;

        try {
            const { data } = await axios.get(
                `${api_url}/orders?page=1&limit=100&date=${date}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
                      },
                }
            );
            setOrders(data.orders);
        } catch (e) {
            console.error("Error fetching orders", e);
        }
    };

    // Update order status API call
    const fetchupdateStatus = async (id, status) => {
        try {
            const { data } = await axios.patch(
                `${api_url}/order/${id}`,
                { order_status: status },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
                      },
                }
            );
            setOrders(data.orders);
            setTrigger(!trigger);
            setSelectedOrder(null);
            alert('Update Success');
        } catch (e) {
            console.log(e);
        }
    };

    // Debounce the filter changes
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedFilters(filters); // Update the debounced filter values after a delay
        }, 500); // Delay time in milliseconds (500ms debounce)

        return () => clearTimeout(timer); // Clean up the timeout if filters change before the delay
    }, [filters]);

    // Fetch orders when the debounced filters change or the trigger changes
    useEffect(() => {
        fetchOrder();
    }, [debouncedFilters, trigger]);

    // Reset Filters
    const resetFilters = () => {
        setFilters({
            date: "",
            amount: "",
            city: "",
        });
    };

    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            <h1 className="text-2xl font-bold mb-4">Orders List</h1>


            <div className="flex gap-4 mb-6">
                <input
                    type="date"
                    className="p-2 border border-gray-300 rounded"
                    placeholder="Filter by date"
                    value={filters.date}
                    onChange={(e) => setFilters({ ...filters, date: e.target.value })}
                />
                <input
                    type="number"
                    className="p-2 border border-gray-300 rounded"
                    placeholder="Filter by amount"
                    value={filters.amount}
                    onChange={(e) => setFilters({ ...filters, amount: e.target.value })}
                />
                <input
                    type="text"
                    className="p-2 border border-gray-300 rounded"
                    placeholder="Filter by city"
                    value={filters.city}
                    onChange={(e) => setFilters({ ...filters, city: e.target.value })}
                />
                {/* Reset Button */}
                <button
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                    onClick={resetFilters}
                >
                    Reset Filters
                </button>
                <div className="bg-green-500 flex items-center px-5 rounded-lg
                 hover:text-white cursor-pointer hover:bg-green-400 transition-all duration-400 hover:scale-x-105">

                    <DownloadTableExcel
                        filename="users table"
                        sheet="users"
                        currentTableRef={tableRef.current}
                    >

                        <button> Export excel </button>

                    </DownloadTableExcel>
                </div>
            </div>

            {/* Orders Table */}
            <div className="overflow-x-auto text-xs bg-white h-[700px] overflow-y-scroll py-10 px-2 rounded-xl">
                <table className="table-auto w-full border-collapse border border-gray-200" ref={tableRef}>
                    <thead>
                        <tr className="bg-gray-200 rounded-tr-lg">
                            <th className="p-4 first:rounded-tl-lg max-w-[50px]">Order ID</th>
                            <th className="p-4 border">Username</th>
                            <th className="p-4 border">Email</th>
                            <th className="p-4 border">Billing Address</th>
                            {/* <th className="p-4 border">Shipping Address</th> */}
                            <th className="p-4 border">Phone No</th>
                            <th className="p-4 border">Product Details</th>
                            <th className="p-4 border ">Status</th>
                            <th className="p-4 border last:rounded-tr-xl">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders?.length > 0 && orders.map((order) => (
                            <tr key={order.id} className="odd:bg-white even:bg-gray-50">
                                <td className="p-4 border max-w-[100px] text-wrap break-words ">{order.order_id}</td>
                                <td className="p-4 border max-w-[100px] text-wrap break-words ">{order.user.first_name}</td>
                                <td className="p-4 border max-w-[160px] text-wrap break-words overflow-hidden">{order.user.email}</td>
                                <td className="p-4 border  max-w-[100px] text-wrap break-words overflow-hidden">{order.address.address}</td>
                                {/* <td className="p-4 border">{order.address.address}</td> */}
                                <td className="p-4 border">{order.user.mobile_number}</td>
                                <td className="p-4 border">
                                    <div className="flex flex-col">

                                        <span>Name : {order.OrderProduct[0]?.product_name}</span>
                                        <span>Quantity : {order.OrderProduct[0]?.quantity}</span>
                                        <span>Size : {order.OrderProduct[0]?.variant.size === '' ? 'Free' : order.OrderProduct[0]?.variant.size}</span>
                                        {/* <span>Total Products : {order.OrderProduct.length}</span> */}
                                    </div>

                                </td>
                                <td className="p-4 border  ">{order.TrackOrder[0]?.order_status}</td>
                                <td className="p-4 border">
                                    <button
                                        className="px-4 py-2 bg-[#5FBDB3] text-white rounded hover:bg-[#3d7b74]"
                                        onClick={() => setSelectedOrder(order)}
                                    >
                                        Update
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Modal for Updating Status */}
            {selectedOrder && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white p-6 rounded shadow-lg w-96">
                        <h2 className="text-lg font-bold mb-4">
                            Update Status for Order {selectedOrder.order_id}
                        </h2>
                        <select
                            className="w-full p-2 border border-gray-300 rounded mb-4"
                            value={newStatus}
                            onChange={(e) => setNewStatus(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="">Select Status</option>
                            <option value="Order_Placed">Order Placed</option>
                            <option value="Ready_for_Ship">Ready for Ship</option>
                            <option value="Scheduled_for_pickup">Scheduled for Pickup</option>
                            <option value="In_Transit">In Transit</option>
                            <option value="Out_for_Delivery">Out for Delivery</option>
                            <option value="Delivered">Delivered</option>
                            <option value="Cancelled">Cancelled</option>

                        </select>
                        <div className="flex justify-end gap-4">
                            <button
                                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                                onClick={() => setSelectedOrder(null)}
                            >
                                Cancel
                            </button>
                            <button
                                className="px-4 py-2 bg-[#5FBDB3] text-white rounded hover:bg-[#5e9993]"
                                onClick={() => fetchupdateStatus(selectedOrder.order_id, newStatus)}
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ListOrder;
